import {createContext} from 'use-context-selector';

export const DispatchContext = createContext();

export default createContext();
